<template>
    <h5>Modificar Tipster</h5>

    <Form role="form" class="text-start mt-4" :validation-schema="schema" @submit="handleEditaTipster">

        <soft-field id="nombre" type="text" :useLabel="true" label="Nombre" name="nombre" v-model="tipsterEditNombre" class="mb-2 label-input2" largo="50"/>

        <soft-field id="username" type="text" :useLabel="true" label="Usuario" name="username" v-model="tipsterEditUsername" class="mb-2 label-input2" largo="30"/>

        <soft-field id="contacto" type="text" :useLabel="true" label="Contacto" name="contacto" v-model="tipsterEditContacto" class="mb-2 label-input2" largo="80"/>

        <soft-field id="email" type="email" :useLabel="true" label="Email" name="email" v-model="tipsterEditEmail" class="mb-2 label-input2" largo="80"/>

        <!--<soft-field id="telefono" type="tel" :useLabel="true" label="Teléfono" name="telefono" v-model="tipsterEditTelefono" class="mb-2 label-input2" largo="20"/>-->
        <div class="mb-0 label-input2">
            <label>Teléfono</label>
            <vue-tel-input
                v-model="tipsterEditTelefono"
                name="telefono"
                default-country="es"
                :only-countries="['es','fr','pt','de','nl','ie','gb','mx','ar','cl','br']"
                :valid-character-only="true"
                :auto-format="false"
                placeholder="Indique teléfono"
                :inputoptions="{ showDialCode: true, placeholder: 'E164' }"
                @input="checkValidPhoneNumber"
                @country-changed="handleCountryChange"
            />
        </div>

        <div v-if="!isValidPhoneNumber" class="error-feedback text-xs text-danger mb-4">
            El teléfono indicado es erróneo
        </div>

        <hr class="my-3">
        <h6 class="mb-3" style="color:#344767">Stripe (cuenta propia)</h6>

        <div class="campos-verticales">
          <soft-field id="stripe_public_key" type="text" :useLabel="true" label="Public Key (pk_...)" name="stripe_public_key"
              v-model="tipsterEditStripePublic" class="mb-3 label-input2" largo="200" autocomplete="off"/>

          <soft-field id="stripe_secret_key" type="password" :useLabel="true"
              :label="stripeSecretSet ? 'Secret Key (dejar vacío para no cambiar)' : 'Secret Key (sk_...)'"
              name="stripe_secret_key"
              v-model="tipsterEditStripeSecret" class="mb-1 label-input2" largo="200" autocomplete="new-password"/>

          <small v-if="stripeSecretSet" class="text-muted d-block mb-3">
            Ya tiene una Secret Key configurada. Deja vacío para conservarla.
          </small>
        </div>

        <!-- Guía Webhook Stripe -->
        <div class="webhook-guide mt-3 mb-2">
          <div class="webhook-guide-header" @click="webhookGuideOpen = !webhookGuideOpen">
            <span>⚡ Configurar Webhook en Stripe (necesario para suscripciones)</span>
            <span class="webhook-chevron">{{ webhookGuideOpen ? '▲' : '▼' }}</span>
          </div>
          <div v-if="webhookGuideOpen" class="webhook-guide-body">
            <p class="mb-3">
              Si ofreces productos de <strong>suscripción mensual</strong>, debes registrar un webhook en tu cuenta de Stripe
              para que Quanty reciba los eventos de cobro, fallo de pago y cancelación automáticamente.
            </p>

            <ol class="webhook-steps">
              <li>
                Accede a tu panel de Stripe:
                <a href="https://dashboard.stripe.com/webhooks" target="_blank" rel="noopener">dashboard.stripe.com/webhooks</a>
              </li>
              <li>
                Haz clic en <strong>"Añadir endpoint"</strong> (o <em>Add endpoint</em>).
              </li>
              <li>
                En el campo <strong>URL del endpoint</strong> pega exactamente esta dirección:
                <div class="webhook-url-box">
                  <code>{{ webhookUrl }}</code>
                  <button type="button" class="btn-copy-webhook" @click.prevent="copiarWebhookUrl">
                    {{ copiado ? '✓ Copiado' : 'Copiar' }}
                  </button>
                </div>
              </li>
              <li>
                En <strong>"Seleccionar eventos"</strong> activa estos siete:
                <ul class="webhook-events">
                  <li><code>customer.subscription.deleted</code> — marca la suscripción como cancelada</li>
                  <li><code>invoice.paid</code> — renueva automáticamente la suscripción cada mes</li>
                  <li><code>invoice.payment_failed</code> — activa el periodo de gracia si falla el cobro</li>
                  <li><code>payment_intent.succeeded</code> — confirma el primer pago</li>
                  <li><code>payment_intent.payment_failed</code> — registra el fallo del primer pago</li>
                  <li><code>charge.refunded</code> — registra devoluciones realizadas desde Stripe</li>
                  <li><code>charge.dispute.created</code> — alerta cuando se abre un contracargo (chargeback)</li>
                </ul>
              </li>
              <li>
                Guarda el endpoint. Stripe te mostrará un <strong>Signing Secret</strong> (empieza por <code>whsec_...</code>).
              </li>
              <li>
                Copia ese <em>Signing Secret</em> y pégalo en el campo <strong>"Webhook Secret"</strong> de abajo.
              </li>
            </ol>

            <div class="webhook-tip">
              💡 Usa las claves de <strong>test</strong> (<code>pk_test_...</code> / <code>sk_test_...</code>) mientras pruebas,
              y cámbia a las de <strong>live</strong> cuando vayas a producción. El webhook secret también cambia entre entornos.
            </div>
          </div>
        </div>

        <div class="campos-verticales">
          <soft-field id="stripe_webhook_secret" type="password" :useLabel="true"
              :label="stripeWebhookSet ? 'Webhook Secret (dejar vacío para no cambiar)' : 'Webhook Secret (whsec_...)'"
              name="stripe_webhook_secret"
              v-model="tipsterEditStripeWebhook" class="mb-1 label-input2" largo="200" autocomplete="new-password"/>

          <small v-if="stripeWebhookSet" class="text-muted d-block mb-3">
            Ya tiene un Webhook Secret configurado. Deja vacío para conservarlo.
          </small>
        </div>

        <hr class="my-3">
        <h6 class="mb-3" style="color:#344767">Comisión</h6>

        <div class="campos-verticales">
          <soft-field id="comision_porcentaje" type="number" :useLabel="true" label="Comisión % (deja vacío para usar la global)" name="comision_porcentaje"
              v-model="tipsterEditComision" class="mb-2 label-input2" largo="10"/>
        </div>

        <hr class="my-3">
        <h6 class="mb-2" style="color:#344767">Panel Tipster</h6>

        <div class="premium-switch-row mb-2">
          <label class="premium-label">Ver sección Campañas en Panel Tipster</label>
          <div class="form-check form-switch mb-0">
            <input class="form-check-input" type="checkbox" v-model="panelCampanas" />
          </div>
        </div>

        <hr class="my-3">
        <h6 class="mb-2" style="color:#344767">Bot Telegram</h6>

        <div class="premium-switch-row mb-2">
          <label class="premium-label">Aceptar nuevos miembros automáticamente</label>
          <div class="form-check form-switch mb-0">
            <input class="form-check-input" type="checkbox" v-model="autoAceptarMiembros" />
          </div>
        </div>

        <hr class="my-3">
        <h6 class="mb-2" style="color:#344767">Bot premium</h6>

        <div class="premium-switch-row mb-2">
          <label class="premium-label">Activar servicio premium</label>
          <div class="form-check form-switch mb-0">
            <input class="form-check-input" type="checkbox" v-model="servicioPremium" />
          </div>
        </div>

        <div v-if="servicioPremium" class="premium-switch-row mb-2">
          <label class="premium-label text-muted" style="font-size:0.82rem">Reenviar enlace de vinculación</label>
          <div class="form-check form-switch mb-0">
            <input class="form-check-input" type="checkbox" v-model="reenviarBotPremium" />
          </div>
        </div>

        <div v-if="ultimoBotLink" class="premium-botlink mb-2">
          <span class="text-xs text-muted">Último enlace generado:</span><br>
          <a :href="ultimoBotLink" target="_blank" class="text-xs">{{ ultimoBotLink }}</a>
        </div>

        <!-- BOTONES -->
        <div class="q-flex-between q-mar-top q-actions">
        <!-- IMPORTANTE: type="button" para que NO dispare el submit -->
        <button type="button" class="btn-q-secondary" @click="$emit('cerrar-modal')">
            Volver
        </button>

        <button
            type="submit"
            class="btn-q-primary"
            :disabled="loading || !isValidPhoneNumber"
        >
            <span v-if="loading" class="spinner-border spinner-border-sm"></span>
            <span v-else>Confirmar</span>
        </button>
        </div>

    </Form>
  </template>

  <script>
  import SoftField from "@/components/SoftField.vue";

  import showSwal from "/src/mixins/showSwal.js";
  import Swal from "sweetalert2";
  import { Form } from "vee-validate";
  import * as yup from "yup";
  import { isValidPhoneNumber } from 'libphonenumber-js';

  export default {
    name: "EditaTipsterForm",
    components: {
        SoftField,

        Form
    },
    props: {
        tipsterId: Number,
        tipsterName: String,
        tipsterEmail: String,
        tipsterContacto: String,
        tipsterTelefono: String,
    },
    data() {
        const schema = yup.object().shape({
            nombre: yup.string().required("El nombre es necesario!").max(50,'El tamaño máximo es de 50 caracteres'),
            contacto: yup.string().required("El contacto es necesario!").max(50,'El tamaño máximo es de 80 caracteres'),
            email: yup.string().email('El email no tiene un formato válido').required("El email es necesario!").max(80,'El tamaño máximo es de 80 caracteres'),
            telefono: yup.string(),
        });
        return {
            loading: false,
            schema,
            tipsterEditId: this.tipsterId,
            tipsterEditNombre: this.tipsterName,
            tipsterEditUsername: '',
            tipsterEditEmail: this.tipsterEmail,
            tipsterEditContacto: this.tipsterContacto,
            tipsterEditTelefono: this.tipsterTelefono,
            tipsterEditStripePublic: '',
            tipsterEditStripeSecret: '',
            tipsterEditStripeWebhook: '',
            tipsterEditComision: '',
            stripeSecretSet: false,
            stripeWebhookSet: false,
            stripeWebhookUuid: '',
            isValidPhoneNumber: true,
            panelCampanas: false,
            autoAceptarMiembros: false,
            servicioPremium: false,
            reenviarBotPremium: false,
            ultimoBotLink: null,
            webhookGuideOpen: false,
            copiado: false,
        };
    },
    emits: ['cerrar-modal'],
    async mounted() {
        if (this.tipsterId) {
            try {
                const resp = await this.$store.dispatch("auth/detalleTipster", { id: this.tipsterId });
                if (resp?.res === 'OK') {
                    this.tipsterEditUsername = resp.username || '';
                    this.tipsterEditStripePublic = resp.stripe_public_key || '';
                    this.stripeSecretSet = resp.stripe_secret_key_set || false;
                    this.stripeWebhookSet = resp.stripe_webhook_secret_set || false;
                    this.stripeWebhookUuid = resp.stripe_webhook_uuid || '';
                    this.tipsterEditComision = resp.comision_porcentaje ?? '';
                    this.panelCampanas = !!resp.panel_campanas;
                    this.autoAceptarMiembros = !!resp.auto_aceptar_miembros;
                    this.servicioPremium = !!resp.servicio_premium;
                }
            } catch (e) { /* si falla, campos quedan vacíos */ }
        }
    },
    computed: {
        webhookUrl() {
            const base = (process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '');
            return this.stripeWebhookUuid
                ? `${base}/api/v2/stripe/webhook/${this.stripeWebhookUuid}`
                : `${base}/api/v2/stripe/webhook`;
        },
    },
    methods: {
        async handleEditaTipster() {
            this.loading = true;
            try {
                let user = {
                    id:                  this.tipsterEditId,
                    nombre:              this.tipsterEditNombre,
                    username:            this.tipsterEditUsername,
                    email:               this.tipsterEditEmail,
                    contacto:            this.tipsterEditContacto,
                    telefono:            this.tipsterEditTelefono,
                    stripe_public_key:    this.tipsterEditStripePublic,
                    stripe_secret_key:    this.tipsterEditStripeSecret,
                    stripe_webhook_secret: this.tipsterEditStripeWebhook,
                    comision_porcentaje: this.tipsterEditComision !== '' ? this.tipsterEditComision : null,
                    panel_campanas:          this.panelCampanas ? 1 : 0,
                    auto_aceptar_miembros:   this.autoAceptarMiembros ? 1 : 0,
                    servicio_premium:        this.servicioPremium ? 1 : 0,
                    reenviar_bot_premium: this.reenviarBotPremium ? 1 : 0,
                };

                this.loading = false;
                const resp = await this.$store.dispatch("auth/guardaTipster", user);
                if (resp.res=='OK') {
                    this.reenviarBotPremium = false;
                    if (resp.bot_link) {
                        this.ultimoBotLink = resp.bot_link;
                    }
                    this.$emit('cerrar-modal');
                    if (resp.bot_link) {
                        await Swal.fire({
                            icon: "success",
                            title: "Tipster actualizado",
                            html: `<p style="margin-bottom:8px">Enlace bot premium enviado por email.</p>
                                   <p style="margin-bottom:12px;font-size:0.85rem;color:#a0aec0;">Si el email no llega, comparte este enlace directamente:</p>
                                   <a href="${resp.bot_link}" target="_blank" style="word-break:break-all;font-size:0.9rem;">${resp.bot_link}</a>`,
                            confirmButtonText: "Cerrar",
                            width: 600,
                            background: "#0e141f",
                            color: "#e7edf5",
                        });
                    } else {
                        showSwal.methods.showSwal({
                            type: "success",
                            message: "Se ha actualizado el tipster",
                            width: 500,
                        });
                    }
                }
                else {
                    showSwal.methods.showSwal({
                        type: "error",
                        message: resp.mensaje,
                        width: 500
                    });
                }
            } catch (error) {
                this.loading = false;
                showSwal.methods.showSwal({
                    type: "error",
                    message: "Se ha producido un error",
                    width: 500,
                });
            }
        },
        checkValidPhoneNumber() {
            this.isValidPhoneNumber = isValidPhoneNumber(this.tipsterEditTelefono || '');
        },
        async copiarWebhookUrl() {
            try {
                await navigator.clipboard.writeText(this.webhookUrl);
                this.copiado = true;
                setTimeout(() => { this.copiado = false; }, 2000);
            } catch { /* fallback silencioso */ }
        },
        handleCountryChange(countryData) {
            const prefijo = '+' + countryData.dialCode;
            if (this.tipsterEditTelefono.substr(0,prefijo.length)!==prefijo) {
                if (this.tipsterEditTelefono.substr(0,1)=='+') {
                    this.tipsterEditTelefono = prefijo + this.tipsterEditTelefono.substr(3);
                }
                else {
                    this.tipsterEditTelefono = prefijo + this.tipsterEditTelefono;
                }
            }
        },
    },
  };
  </script>

  <style scoped>
.q-mar-top { margin-top: 1rem; }
.q-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.btn-q-primary,
.btn-q-secondary {
  min-width: 180px;
  height: 48px;
  border-radius: 10px;
  font-weight: 600;
  border: none;
  cursor: pointer;
}

.btn-q-primary {
  background: var(--q-gold);
  color: var(--q-gold-on);
}

.btn-q-secondary {
  background: var(--q-hover);
  color: var(--q-text);
}

/* Webhook guide */
.webhook-guide {
  border: 1px solid var(--q-border);
  border-radius: 10px;
  overflow: hidden;
}
.webhook-guide-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background: var(--q-hover);
  cursor: pointer;
  font-weight: 600;
  font-size: 0.85rem;
  color: var(--q-gold);
  user-select: none;
}
.webhook-guide-header:hover { background: var(--q-hover); }
.webhook-chevron { font-size: 0.75rem; opacity: 0.7; }
.webhook-guide-body {
  padding: 16px 16px 12px;
  font-size: 0.83rem;
  color: var(--q-text);
  line-height: 1.55;
}
.webhook-steps {
  padding-left: 18px;
  margin-bottom: 12px;
}
.webhook-steps li { margin-bottom: 10px; }
.webhook-steps a { color: var(--q-gold); word-break: break-all; }
.webhook-url-box {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  border-radius: 6px;
  padding: 7px 10px;
  flex-wrap: wrap;
}
.webhook-url-box code {
  font-size: 0.8rem;
  color: var(--q-red);
  word-break: break-all;
  flex: 1;
}
.btn-copy-webhook {
  flex-shrink: 0;
  padding: 3px 10px;
  border: 1px solid var(--q-gold);
  border-radius: 6px;
  background: var(--q-card);
  color: var(--q-gold);
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
}
.btn-copy-webhook:hover { background: var(--q-hover); }
.webhook-events {
  margin-top: 8px;
  padding-left: 16px;
}
.webhook-events li { margin-bottom: 6px; }
.webhook-events code { background: var(--q-hover); padding: 1px 5px; border-radius: 4px; font-size: 0.8rem; color: var(--q-red); }
.webhook-tip {
  background: var(--q-amber-soft);
  border-left: 3px solid var(--q-amber);
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 0.8rem;
  color: var(--q-text);
}

/* Bot premium */
.premium-switch-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.premium-label {
  font-size: 0.85rem;
  color: var(--q-text);
  margin: 0;
}
.premium-botlink {
  background: var(--q-hover);
  border-radius: 6px;
  padding: 8px 12px;
  word-break: break-all;
}

/* Campos Stripe/Comisión en columna (label arriba, input abajo) */
.campos-verticales :deep(.label-input2),
.campos-verticales :deep(.label-input2 > div) {
  flex-direction: column;
  align-items: flex-start;
}
.campos-verticales :deep(.label-input2) label {
  flex: 1 1 100% !important;
  width: 100%;
  white-space: normal;
  margin-bottom: 4px;
  font-size: 0.85rem;
}
.campos-verticales :deep(.label-input2) input {
  width: 100%;
  flex: none;
}

/* Teléfono: iguala estilo visual a soft-field */
:deep(.vue-tel-input) {
  background-color: var(--q-card-alt) !important;
  border: 1px solid var(--q-border) !important;
  border-radius: 10px !important;
  padding: 0 !important;
  box-shadow: none;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}
:deep(.vue-tel-input:focus-within) {
  border-color: var(--q-gold) !important;
  box-shadow: 0 0 0 3px rgba(245,166,35,0.2) !important;
}
:deep(.vue-tel-input .vti__dropdown) {
  background: transparent;
  border-right: 1px solid var(--q-border);
  border-radius: 10px 0 0 10px;
  padding: 0 8px;
}
:deep(.vue-tel-input .vti__input) {
  background: transparent !important;
  border: none !important;
  border-radius: 0 10px 10px 0 !important;
  padding: 0.35rem 0.75rem !important;
  font-size: 0.875rem;
  color: var(--q-text);
}

/* ✅ Mobile: botones en columna y siempre accesibles */
@media (max-width: 768px) {
  .q-flex-between {
    flex-direction: column;
    align-items: stretch;
  }
  .btn-q-primary,
  .btn-q-secondary {
    width: 100%;
  }

  /* (opcional pro) barra de acciones pegada abajo dentro del modal */
  .q-actions {
    position: sticky;
    bottom: 0;
    background: var(--q-card);
    padding: 12px 0 calc(12px + env(safe-area-inset-bottom));
    border-top: 1px solid var(--q-border);
    z-index: 3;
  }
}
  </style>
